import React, { useEffect, useState } from 'react'
import { ColumnProps, CompositeView, FilterWidget, FormSelect, GridView, SimpleView, Table, Widget } from '@digital/ui'
import { MonitoramentoSubcontracacaoFilter, MonitoramentoSubcontracacaoResult, exportToExcel, findAll } from '@app/api/relatorioMonitoramentoSubcontratacoes';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasOptions } from '@app/api/area';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getContratoOptionsForSelect } from '@app/api/contrato';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { mountFormFilterDropDown, mountFormFilterDropDownDateRange } from '@app/utils/formFilterDropDown';
import { compareDates, compareNumberString, compareText } from '@app/helpers/comparators';
import moment from 'moment';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';

const RelatorioMonitoramentoSubcontratacoes = () => {
    const [items, setItems] = useState<MonitoramentoSubcontracacaoResult[]>();


    const handleFilter = (values: MonitoramentoSubcontracacaoFilter) => {
        findAll(values).then(resp => resp && setItems(
            resp.map((item: any) => {
                return {
                  ...item,
                  dataConsulta: moment(convertUTCtoLocal(moment(item.dataConsulta))).format('DD/MM/YYYY'),
                  dataResposta: moment(convertUTCtoLocal(moment(item.dataResposta))).format('DD/MM/YYYY'),
                };
              })
        ));
        
    };

    const handleExcel = async (values: MonitoramentoSubcontracacaoFilter) => {
        exportToExcel(values);
    };

    useEffect(() => {
        handleFilter({} as MonitoramentoSubcontracacaoFilter);
    }, [])

    const columns: ColumnProps<MonitoramentoSubcontracacaoResult>[] = [
        {
            title: 'Número',
            dataIndex: 'contratoNumero',
            sorter: (a, b) => compareNumberString(a.contratoNumero, b.contratoNumero),
            ...mountFormFilterDropDown('contratoNumero', 'Pesquisar'),
        },
        {
            title: 'Código',
            dataIndex: 'fornecedorNumero',
            sorter: (a, b) => compareNumberString(a.fornecedorNumero, b.fornecedorNumero),
            ...mountFormFilterDropDown('fornecedorNumero', 'Pesquisar'),
        },
        {
            title:'CNPJ',
            dataIndex: 'fornecedorCnpj',
            sorter: (a, b) => compareText(a.fornecedorNumero, b.fornecedorNumero),
            ...mountFormFilterDropDown('fornecedorCnpj', 'Pesquisar'),
        },
        {
            title:'Nome',
            dataIndex: 'fornecedorNome',
            sorter: (a, b) => compareText(a.fornecedorNome, b.fornecedorNome),
            ...mountFormFilterDropDown('fornecedorNome', 'Pesquisar'),
        },
        // {
        //     title:'Fornecedor Resumido',
        //     dataIndex: 'fornecedorNomeResumido',
        //     ...mountFormFilterDropDown('fornecedorNomeResumido', 'Pesquisar'),
        // },
        {
            title:'Objeto Resumido',
            dataIndex: 'contratoObjetoResumido',
            sorter: (a, b) => compareText(a.contratoObjetoResumido, b.contratoObjetoResumido),
            ...mountFormFilterDropDown('contratoObjetoResumido', 'Pesquisar'),
        },
        {
            title:'Status',
            dataIndex: 'contatoStatus',
            sorter: (a, b) => compareText(a.contatoStatus, b.contatoStatus),
            ...mountFormFilterDropDown('contatoStatus', 'Pesquisar'),
        },
        {
            title:'Diretoria',
            dataIndex: 'diretoriaSigla',
            sorter: (a, b) => compareText(a.diretoriaSigla, b.diretoriaSigla),
            ...mountFormFilterDropDown('diretoriaSigla', 'Pesquisar'),
        },
        {
            title:'Área',
            dataIndex: 'areaSigla',
            sorter: (a, b) => compareText(a.areaSigla, b.areaSigla),
            ...mountFormFilterDropDown('areaSigla', 'Pesquisar'),
        },
        {
            title:'Departamento',
            dataIndex: 'departamentoSigla',
            sorter: (a, b) => compareText(a.departamentoSigla, b.departamentoSigla),
            ...mountFormFilterDropDown('departamentoSigla', 'Pesquisar'),
        },
        {
            title:'Gestor da MRN',
            dataIndex: 'gestorNome',
            sorter: (a, b) => compareText(a.gestorNome, b.gestorNome),
            ...mountFormFilterDropDown('gestorNome', 'Pesquisar'),
        },
        {
            title:'Fiscal da MRN',
            dataIndex: 'fiscalNome',
            sorter: (a, b) => compareText(a.fiscalNome, b.fiscalNome),
            ...mountFormFilterDropDown('fiscalNome', 'Pesquisar'),
        },
        {
            title:'Administrador GPC',
            dataIndex: 'administradorNome',
            sorter: (a, b) => compareText(a.administradorNome, b.administradorNome),
            ...mountFormFilterDropDown('administradorNome', 'Pesquisar'),
        },
        {
            title:'Data Consulta',
            dataIndex: 'dataConsulta',
            sorter: (a, b) => compareDates(a.dataConsulta, b.dataConsulta),
            ...mountFormFilterDropDownDateRange('dataConsulta'),
        },
        {
            title:'Respondida?',
            dataIndex: 'isRespondida',
            sorter: (a, b) => compareText(a.isRespondida, b.isRespondida),
            ...mountFormFilterDropDown('isRespondida', 'Pesquisar'),
        },
        {
            title:'Data Resposta',
            dataIndex: 'dataResposta',
            sorter: (a, b) => compareDates(a.dataResposta, b.dataResposta),
            ...mountFormFilterDropDownDateRange('dataResposta'),
        },
        {
            title:'Resposta',
            dataIndex: 'resposta',
            sorter: (a, b) => compareText(a.resposta, b.resposta),
            ...mountFormFilterDropDown('Resposta', 'Pesquisar'),
        },
    ]

    return (
        <CompositeView>
            <SimpleView>
                <GridView onSubmit={handleFilter} >
                    <FilterWidget
                        active={[]}
                        actions={[
                            <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
                            <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
                        ]}
                        title='Filtros'
                    >
                        <FormSelect
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, item: any) => {
                                return item.props.children.props.id
                                    .toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                            }}
                            mode="multiple"
                            label="Diretoria"
                            name="diretoriaIds"
                            getOptions={getAllDiretoriasOptions}
                            span={4}
                        />
                        <FormSelect
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, item: any) => {
                                return item.props.children.props.id
                                    .toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                            }}
                            mode="multiple"
                            label="Área"
                            name="areaIds"
                            getOptions={getAllAreasOptions}
                            span={4}
                        />
                        <FormSelect
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, item: any) => {
                                return item.props.children.props.id
                                    .toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                            }}
                            mode="multiple"
                            label="Departamento"
                            name="departamentosIds"
                            getOptions={getAllDepartamentoOptions}
                            span={4}
                        />
                        <FormSelect
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, item: any) => {
                                return item.props.children.props.id
                                    .toString()
                                    .toLowerCase()
                                    .includes(input.toLowerCase());
                            }}
                            mode="multiple"
                            label="Contrato"
                            name="contratosIds"
                            getOptions={getContratoOptionsForSelect}
                            span={12}
                        />
                    </FilterWidget>
                    <Widget title="Relatório Monitoramento de Subcontratações">
                        <Table
                            columns={columns}
                            dataSource={items || []}
                            pagination={{ pageSize: 50 }}
                        />
                    </Widget>
                </GridView>
            </SimpleView>
        </CompositeView>
    )
}

export default RelatorioMonitoramentoSubcontratacoes